"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _InsertComment = _interopRequireDefault(require("@mui/icons-material/InsertComment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _lodash = require("lodash");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _AddComment = _interopRequireDefault(require("../../../dist/components/dialogs/AddComment"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _Grid = _interopRequireWildcard(require("@mui/material/Grid"));
var _surveyUtils = require("../../utilities/surveyUtils");
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomRespondentInformation = /*#__PURE__*/function (_Component) {
  function CustomRespondentInformation(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomRespondentInformation);
    _this = _callSuper(this, CustomRespondentInformation, [props]);
    var serviceList = props.serviceList,
      value = props.value;
    var answers = value ? value.map(function (v) {
      return JSON.parse(v);
    }) : [];
    var respondents = serviceList.map(function (s) {
      var respondent = answers.find(function (a) {
        return a.serviceID === Number(s.value);
      });
      var item = {
        serviceID: Number(s.value),
        name: '',
        title: '',
        email: '',
        nameComment: '',
        titleComment: '',
        emailComment: ''
      };
      if (respondent) {
        item.name = respondent.name;
        item.title = respondent.title;
        item.email = respondent.email;
        item.nameComment = respondent.nameComment;
        item.titleComment = respondent.titleComment;
        item.emailComment = respondent.emailComment;
      }
      return item;
    });
    _this.state = {
      showCommentDialog: false,
      clickedServiceID: '',
      clickedField: '',
      commentVal: '',
      respondents: respondents
    };
    ['handleAddComment', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomRespondentInformation, _Component);
  return (0, _createClass2["default"])(CustomRespondentInformation, [{
    key: "convertToValue",
    value: function convertToValue(respondents) {
      var values = respondents.map(function (v) {
        return JSON.stringify(v);
      });
      return values;
    }
  }, {
    key: "updateText",
    value: function updateText(serviceID, field, value) {
      var _this2 = this;
      var respondents = [].concat(this.state.respondents);
      var respondent = respondents.find(function (r) {
        return r.serviceID === serviceID;
      });
      respondent[field] = value;
      this.setState({
        respondents: respondents
      }, function () {
        _this2.props.onChange(_this2.convertToValue(respondents));
      });
    }
  }, {
    key: "handleAddComment",
    value: function handleAddComment(value, field, serviceID) {
      var _this3 = this;
      var respondents = [].concat(this.state.respondents);
      var respondent = respondents.find(function (r) {
        return r.serviceID === serviceID;
      });
      console.log('handle add comment', value, field, serviceID, respondent);
      respondent[field] = value;
      this.setState({
        respondents: respondents
      }, function () {
        _this3.props.onChange(_this3.convertToValue(respondents));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        serviceList = _this$props.serviceList,
        parentQuestionNumbers = _this$props.parentQuestionNumbers,
        questionNumber = _this$props.questionNumber,
        resources = _this$props.resources,
        language = _this$props.language;
      var _this$state = this.state,
        showCommentDialog = _this$state.showCommentDialog,
        respondents = _this$state.respondents;
      var parentQuestionNumberLabel = parentQuestionNumbers !== null ? "".concat(parentQuestionNumbers.join('.'), ".") : '';
      var questionNumberLabel = "".concat(parentQuestionNumberLabel + (0, _surveyUtils.numberToLetter)(questionNumber), ".");
      return [/*#__PURE__*/_react["default"].createElement(_material.Table, {
        key: "respondentTable"
      }, /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        key: "header",
        style: {
          backgroundColor: '#fafafa'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: 'normal',
        style: {
          width: '20%'
        }
      }), serviceList.map(function (d) {
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText,
          padding: 'normal',
          key: 'colLabel' + d.value
        }, d.label);
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        key: "nameRow"
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: 'normal',
        style: {
          width: '20%'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Respondent Name')), serviceList.map(function (d) {
        var serviceID = Number(d.value);
        var respondent = respondents.find(function (r) {
          return r.serviceID === serviceID;
        });
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          key: 'nameCol' + serviceID,
          className: classes.centerText,
          padding: 'normal'
        }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
          label: "",
          name: "name",
          key: 'name' + serviceID,
          onBlur: function onBlur(e) {
            _this4.updateText(serviceID, 'name', e.target.value);
          },
          defaultValue: respondent.name
        }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          key: 'nameCommentToolTip' + serviceID,
          title: "Add Comment",
          "aria-label": "add"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          disabled: false,
          "aria-label": "Add Comment",
          key: 'nameComment' + serviceID,
          onClick: function onClick() {
            return _this4.setState({
              showCommentDialog: true,
              commentVal: respondent.nameComment,
              clickedField: 'nameComment',
              clickedServiceID: serviceID
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
          key: 'nameCommentIcon' + serviceID,
          color: respondent.nameComment !== '' && respondent.nameComment !== undefined ? 'primary' : 'inherit'
        }, respondent.nameComment)))));
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null)), /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        key: "titleRow"
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: 'normal',
        style: {
          width: '20%'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Title')), serviceList.map(function (d) {
        var serviceID = Number(d.value);
        var respondent = respondents.find(function (r) {
          return r.serviceID === serviceID;
        });
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          key: 'titleCol' + serviceID,
          className: classes.centerText,
          padding: 'normal'
        }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
          label: "",
          name: "title",
          key: 'title' + serviceID,
          onBlur: function onBlur(e) {
            _this4.updateText(serviceID, 'title', e.target.value);
          },
          defaultValue: respondent.title
        }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          key: 'titleCommentToolTip' + serviceID,
          title: "Add Comment",
          "aria-label": "add"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          disabled: false,
          "aria-label": "Add Comment",
          key: 'titleComment' + serviceID,
          onClick: function onClick() {
            return _this4.setState({
              showCommentDialog: true,
              commentVal: respondent.titleComment,
              clickedField: 'titleComment',
              clickedServiceID: serviceID
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
          key: 'titileCommentIcon' + serviceID,
          color: respondent.titleComment !== '' && respondent.titleComment !== undefined ? 'primary' : 'inherit'
        }, respondent.titleComment)))));
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null)), /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        key: "emailRow"
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        padding: 'normal',
        style: {
          width: '20%'
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Email')), serviceList.map(function (d) {
        var serviceID = Number(d.value);
        var respondent = respondents.find(function (r) {
          return r.serviceID === serviceID;
        });
        return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          key: 'emailCol' + serviceID,
          className: classes.centerText,
          padding: 'normal'
        }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
          label: "",
          name: "email",
          key: 'email' + serviceID,
          onBlur: function onBlur(e) {
            _this4.updateText(serviceID, 'email', e.target.value);
          },
          defaultValue: respondent.email
        }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          key: 'emailCommentToolTip' + serviceID,
          title: "Add Comment",
          "aria-label": "add"
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
          disabled: false,
          key: 'emailComment' + serviceID,
          "aria-label": "Add Comment",
          onClick: function onClick() {
            return _this4.setState({
              showCommentDialog: true,
              commentVal: respondent.emailComment,
              clickedField: 'emailComment',
              clickedServiceID: serviceID
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_InsertComment["default"], {
          key: 'emailCommentIcon' + serviceID,
          color: respondent.emailComment !== '' && respondent.emailComment !== undefined ? 'primary' : 'inherit'
        }, respondent.emailComment)))));
      }), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null)))), /*#__PURE__*/_react["default"].createElement(_AddComment["default"], {
        key: "addCommentDialog",
        open: showCommentDialog,
        commentVal: this.state.commentVal,
        title: 'Add/Edit Comment',
        contentText: "(Limited to 100 characters)",
        onConfirm: function onConfirm(comment) {
          _this4.setState({
            showCommentDialog: false
          });
          _this4.handleAddComment(comment, _this4.state.clickedField, _this4.state.clickedServiceID);
        },
        onClose: function onClose() {
          return _this4.setState({
            showCommentDialog: false
          });
        }
      })];
    }
  }]);
}(_react.Component);
CustomRespondentInformation.propTypes = {};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomRespondentInformation);